var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.liaison)?_c('div',{staticClass:"profile-body"},[_c('BackHeader',{attrs:{"is-show-title":"","is-static":"","title":"Member liaison"}}),_c('MemberLiaisonBox',{attrs:{"liaison":_vm.liaison}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }